import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
	selector: 'sm-nav-menu',
	template: require('./sm-nav-menu.component.html')
})
export class SmNavMenuComponent implements OnInit {
	isSm = false;
	subscription: Subscription;

	constructor(private _router: Router) { }

	ngOnInit() {
		this.checkIsSm(this._router.url);

		this.subscription = this._router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				const navigationEnd = event as NavigationEnd;

				this.checkIsSm(navigationEnd.url);
			}
		});
	}

	ngOnDestroy() {
		this.subscription!.unsubscribe();
	}

	private checkIsSm(url: string) {
		this.isSm = (url && url.indexOf('/sm/') == 0) ? true : false;
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/sm-nav-menu.component.ts